"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalEvaluationClient = void 0;
const amplitude = __importStar(require("@amplitude/analytics-node"));
const evaluation_js_1 = __importDefault(require("@amplitude/evaluation-js"));
const assignment_1 = require("../assignment/assignment");
const assignment_filter_1 = require("../assignment/assignment-filter");
const assignment_service_1 = require("../assignment/assignment-service");
const http_1 = require("../transport/http");
const config_1 = require("../types/config");
const logger_1 = require("../util/logger");
const cache_1 = require("./cache");
const fetcher_1 = require("./fetcher");
const poller_1 = require("./poller");
/**
 * Experiment client for evaluating variants for a user locally.
 * @category Core Usage
 */
class LocalEvaluationClient {
    constructor(apiKey, config, flagConfigCache = new cache_1.InMemoryFlagConfigCache(config === null || config === void 0 ? void 0 : config.bootstrap), httpClient = new http_1.FetchHttpClient(config === null || config === void 0 ? void 0 : config.httpAgent)) {
        this.config = Object.assign(Object.assign({}, config_1.LocalEvaluationDefaults), config);
        const fetcher = new fetcher_1.FlagConfigFetcher(apiKey, httpClient, this.config.serverUrl, this.config.debug);
        // We no longer use the flag config cache for accessing variants.
        fetcher.setRawReceiver((flags) => {
            this.flags = JSON.parse(flags);
        });
        this.cache = flagConfigCache;
        this.logger = new logger_1.ConsoleLogger(this.config.debug);
        this.poller = new poller_1.FlagConfigPoller(fetcher, this.cache, this.config.flagConfigPollingIntervalMillis, this.config.debug);
        if (this.config.assignmentConfig) {
            this.config.assignmentConfig = Object.assign(Object.assign({}, config_1.AssignmentConfigDefaults), this.config.assignmentConfig);
            this.assignmentService = this.createAssignmentService(this.config.assignmentConfig);
        }
    }
    createAssignmentService(assignmentConfig) {
        const instance = amplitude.createInstance();
        const { apiKey, cacheCapacity } = assignmentConfig, ampConfig = __rest(assignmentConfig, ["apiKey", "cacheCapacity"]);
        instance.init(apiKey, ampConfig);
        return new assignment_service_1.AmplitudeAssignmentService(instance, new assignment_filter_1.InMemoryAssignmentFilter(cacheCapacity));
    }
    /**
     * Locally evaluates flag variants for a user.
     *
     * This function will only evaluate flags for the keys specified in the
     * {@link flagKeys} argument. If {@link flagKeys} is missing, all flags in the
     * {@link FlagConfigCache} will be evaluated.
     *
     * @param user The user to evaluate
     * @param flagKeys The flags to evaluate with the user. If empty, all flags
     * from the flag cache are evaluated.
     * @returns The evaluated variants
     */
    evaluate(user, flagKeys) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.logger.debug('[Experiment] evaluate - user:', user, 'flags:', this.flags);
            const results = evaluation_js_1.default.evaluate(this.flags, user);
            const assignmentResults = {};
            const variants = {};
            const filter = flagKeys && flagKeys.length > 0;
            for (const flagKey in results) {
                const included = !filter || flagKeys.includes(flagKey);
                if (included) {
                    const flagResult = results[flagKey];
                    variants[flagKey] = {
                        value: flagResult.value,
                        payload: flagResult.payload,
                    };
                }
                if (included ||
                    results[flagKey].type == assignment_service_1.FLAG_TYPE_MUTUAL_EXCLUSION_GROUP ||
                    results[flagKey].type == assignment_service_1.FLAG_TYPE_HOLDOUT_GROUP) {
                    assignmentResults[flagKey] = results[flagKey];
                }
            }
            void ((_a = this.assignmentService) === null || _a === void 0 ? void 0 : _a.track(new assignment_1.Assignment(user, assignmentResults)));
            this.logger.debug('[Experiment] evaluate - variants: ', variants);
            return variants;
        });
    }
    /**
     * Fetch initial flag configurations and start polling for updates.
     *
     * You must call this function to begin polling for flag config updates.
     * The promise returned by this function is resolved when the initial call
     * to fetch the flag configuration completes.
     *
     * Calling this function while the poller is already running does nothing.
     */
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.poller.start();
        });
    }
    /**
     * Stop polling for flag configurations.
     *
     * Calling this function while the poller is not running will do nothing.
     */
    stop() {
        return this.poller.stop();
    }
}
exports.LocalEvaluationClient = LocalEvaluationClient;
